'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _AddContactSuggestForm = require('components/AddContact/AddContactSuggestForm/AddContactSuggestForm');

var _AddContactSuggestForm2 = _interopRequireDefault(_AddContactSuggestForm);

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _contacts2 = require('selectors/contacts');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var AddContactField = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    addContactLoading: state.contacts.addContactLoading,
    suggestionUsersList: (0, _contacts2.getGroupContactsSuggestionList)(state)
  };
}, (0, _extends3.default)({}, contactsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AddContactField, _Component);

  function AddContactField() {
    (0, _classCallCheck3.default)(this, AddContactField);
    return (0, _possibleConstructorReturn3.default)(this, (AddContactField.__proto__ || (0, _getPrototypeOf2.default)(AddContactField)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddContactField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var loadSuggestionUsersList = this.props.loadSuggestionUsersList;

      loadSuggestionUsersList();
    }
  }, {
    key: 'onSuggestionSelected',
    value: function onSuggestionSelected(_ref) {
      var suggestion = _ref.suggestion;
      var onAdd = this.props.onAdd;

      var user = (0, _extends3.default)({}, suggestion);
      return onAdd(user);
    }
  }, {
    key: 'getAutosuggestItems',
    value: function getAutosuggestItems() {
      var suggestionUsersList = this.props.suggestionUsersList;

      var items = [];
      suggestionUsersList.map(function (user) {
        return items.push((0, _extends3.default)({}, user, { _name: user.email, _type: 'user' }));
      });
      return items;
    }
  }, {
    key: 'addContact',
    value: function addContact(data) {
      var onAdd = this.props.onAdd;

      var contact = {
        email: data.userEmail,
        name: data.name,
        surname: data.surname
      };

      onAdd(contact);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          addContactLoading = _props.addContactLoading,
          required = _props.required,
          loading = _props.loading;

      var items = this.getAutosuggestItems();

      return _react2.default.createElement(_AddContactSuggestForm2.default, {
        onSuggestionSelected: this.onSuggestionSelected,
        loading: loading,
        items: items,
        onAddNewContact: this.addContact,
        onAddNewContactLoading: addContactLoading,
        required: required,
        autoFocus: false
      });
    }
  }]);
  return AddContactField;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addContactLoading: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  loadSuggestionUsersList: _propTypes2.default.func,
  onAdd: _propTypes2.default.func,
  required: _propTypes2.default.bool,
  suggestionUsersList: _propTypes2.default.array
}, _class3.defaultProps = {
  onAdd: _noop3.default,
  onAddGroup: _noop3.default,
  recipientsList: [],
  withTags: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addContact', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addContact'), _class2.prototype)), _class2)) || _class);
exports.default = AddContactField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/AddContactField/AddContactField.js
// module id = 2147
// module chunks = 1